import React from "react";

function Button({ content, isLoading = false, style = {}, ...props }) {
  return (
    <div
      style={{
        color: "white",
        background: isLoading ? "gray" : "var(--color-secondary)",
        padding: "6px 10px",
        fontFamily: "Lato",
        fontSize: "12px",
        fontWeight: "900",
        letterSpacing: "0.5px",
        cursor: isLoading ? "not-allowed" : "pointer",
        borderRadius: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: isLoading ? 0.7 : 1,
        pointerEvents: isLoading ? "none" : "auto",
        ...style,
      }}
      {...props}
    >
      {isLoading ? (
        <>
          <div
            style={{
              width: "16px",
              height: "16px",
              marginRight: "7px",
              border: "2px solid white",
              borderTop: "2px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />
          <span>Loading</span>
        </>
      ) : (
        content
      )}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default Button;
